import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import { encodeColor } from '../tgccRequest';



const containDiv: CSSProperties = {
    height:'392px',
    width:'100%',
    backgroundColor:'#748092',
    display:'flex',
    marginTop:'5%'
}
const leftWhoDiv: CSSProperties = {
    color:'white',
    display:'flex',
    flexDirection:'column',
    padding:'30px',
    justifyContent:'center'
}

const rightWhoDiv: CSSProperties = {
    width:'50%'
}
const whoTxt: CSSProperties = {
    fontFamily:'BarlowMedium',
    width:'75%',
    fontSize:'20px',
    display:'flex',
    alignSelf:'center'
}
const rightWho: CSSProperties = {
    color:'white',
    fontFamily:'Lulo',
    fontSize:'40px',
    textAlign:'center',
    marginBottom:'4%'
}

class _WhoWeAre extends React.Component<Tgcc.BaseProps, any> {  
openHowItWorks = () =>{browserHistory.push(Tgcc.Routes.CampusHowItWorks)}
    render() {      
        return (<div style={containDiv} className="whatisreal">
                    <div style={leftWhoDiv} className="rcLeft">
                    <div style={rightWho}>WHAT IS REAL CAMPUS?</div>
                        <div style={whoTxt} className="rc_who">Real Campus is a collaboration between Hanesbrands and The Graphic Cow that encourages students to show their involvement using licensed branded apparel.  This collaboration makes designing and ordering custom apparel easier than ever.  Hanesbrands, the industry leader, offers a full line of branded apparel including Champion, and The Graphic Cow's delivers a cutting-edge technology platform.  These two companies are teaming up, and the students are the winners. </div> 
                    </div>
                </div>   
        )
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var WhoWeAre = connect(mapStateToProps)(Radium(_WhoWeAre));
